/**
 * 唤起 PC 客户端所需的参数
 */
export interface LaunchAppParams {
  app: string
  action: string
  resourcecode: string
  env: string
}

/**
 * 根据参数拼接自定义协议唤起地址。
 * 格式：{app}://{action}?resourcecode={resourcecode}&env={env}
 * @param params - 唤起所需的四个参数
 * @returns 拼接后的协议地址
 */
export function buildLaunchUrl(params: LaunchAppParams): string {
  const { app, action, resourcecode, env } = params
  // 用 URLSearchParams 拼接 query，自动处理特殊字符编码
  const query = new URLSearchParams({ resourcecode, env }).toString()
  return `${app}://${action}?${query}`
}

/**
 * 尝试唤起 PC 端应用（自定义协议）。
 * 说明：对自定义协议赋值 location.href 不会让当前网页跳走；
 * 未安装 / 用户取消 / 唤起失败时浏览器会静默失败，页面原地保持不变，无需兜底。
 * @param schemeUrl - 完整的协议唤起地址
 */
export function launchPcApp(schemeUrl: string): void {
  // 仅在浏览器端执行（双保险，避免 SSR 环境误用）
  if (typeof window === 'undefined') return
  window.location.href = schemeUrl
}

/**
 * 从当前地址栏移除指定的 query 参数。
 * 使用 history.replaceState 实现：不刷新、不跳转、不新增历史记录，
 * 且保留 URL 上其它 query 参数与 hash。
 * @param keys - 需要移除的 query 参数名
 */
export function removeQueryKeys(keys: string[]): void {
  // 仅在浏览器端执行
  if (typeof window === 'undefined') return
  const url = new URL(window.location.href)
  keys.forEach((key) => url.searchParams.delete(key))
  // 保留当前 history state（Nuxt 路由依赖它），仅替换 URL
  window.history.replaceState(window.history.state, '', url.toString())
}
